//TODO: refactor
// used for nav list at the top of the page
const getPersistedValue = (key) => {
    const sessionValue = sessionStorage.getItem(key);

    if (sessionValue !== null) {
        return sessionValue;
    }

    return localStorage.getItem(key);
};

const getCurrentCompany = () => {
    return getPersistedValue('currentCompany');
};
const getCurrentPartner = () => {
    return getPersistedValue('currentPartner');
};
const getCurrentWholesaler = () => {
    return getPersistedValue('currentWholesaler');
};
// Neither record is cached in storage or held in this slice any more — only the
// selected IDs are. Both come from queries: `useGetCurrentCompany`
// (['company', currentCompany]) and `useGetCurrentWholesaler`
// (['wholesaler', currentWholesaler]). Clear what earlier builds left on disk;
// those blobs held tenant IDs, the MSOL sync username and contact details.
const purgeCachedEntityRecords = () => {
    try {
        localStorage.removeItem('currentCompanyData');
        localStorage.removeItem('currentWholesalerData');
    } catch (error) {
        // Private mode or blocked site data — nothing cached to remove.
    }
};

purgeCachedEntityRecords();

const currentCompany =
    getCurrentCompany() === 'null' ? null : getCurrentCompany();
const currentWholesaler =
    getCurrentWholesaler() === 'null' ? null : getCurrentWholesaler();
const initNavListState = {
    companiesAndPartners: [],
    wholesalers: [],
    companiesAndPartnersLoading: true,
    wholesalersLoading: true,
    currentPartner: getCurrentPartner() === 'null' ? null : getCurrentPartner(),
    currentWholesaler,
    currentCompany,
    currentCompanyPlatforms: null,
};

export const navigationListsReducer = (state = initNavListState, action) => {
    switch (action.type) {
        case 'CHANGE_COMPANIES_AND_PARTNERS_LOADING':
            return { ...state, companiesAndPartnersLoading: action.payload };
        case 'CHANGE_WHOLESALERS_LOADING':
            return { ...state, wholesalersLoading: action.payload };
        case 'CHANGE_COMPANIES_AND_PARTNERS':
            return { ...state, companiesAndPartners: action.payload };
        case 'CHANGE_WHOLESALERS':
            return { ...state, wholesalers: action.payload };
        case 'CHANGE_CURRENT_COMPANY':
            sessionStorage.setItem('currentCompany', action.payload);
            localStorage.setItem('currentCompany', action.payload);
            // Reset platforms so stale data from the previous company does not
            // persist (Bug 2329: numbers table hidden after switching to a
            // company with fewer/zero platforms).
            return {
                ...state,
                currentCompany: action.payload,
                currentCompanyPlatforms: null,
            };
        case 'CHANGE_CURRENT_COMPANY_PLATFORMS':
            return { ...state, currentCompanyPlatforms: action.payload };
        case 'CHANGE_CURRENT_PARTNER':
            sessionStorage.setItem('currentPartner', action.payload);
            localStorage.setItem('currentPartner', action.payload);
            return { ...state, currentPartner: action.payload };
        case 'CHANGE_CURRENT_WHOLESALER':
            sessionStorage.setItem('currentWholesaler', action.payload);
            localStorage.setItem('currentWholesaler', action.payload);
            return { ...state, currentWholesaler: action.payload };
        case 'LOGOUT':
            sessionStorage.clear();
            localStorage.removeItem('currentCompany');
            localStorage.removeItem('currentPartner');
            localStorage.removeItem('currentWholesaler');
            return {
                companiesAndPartners: [],
                wholesalers: [],
                companiesAndPartnersLoading: true,
                wholesalersLoading: true,
                currentPartner: null,
                currentWholesaler: null,
                currentCompany: null,
                currentCompanyPlatforms: null,
            };

        default:
            return state;
    }
};
